<template>
  <div class="page-container">
    <van-nav-bar left-arrow fixed :z-index="10" @click-left="goableBack()" :title="item.title"></van-nav-bar>
    <pdf v-for="item in numPages" :key="item" :src="src" :page="item" />
  </div>
</template>
<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js" />
<script>
import { NavBar, Toast } from 'vant'
import pdf from 'vue-pdf-sign'
import CMapReaderFactory from 'vue-pdf-sign/src/CMapReaderFactory.js'
export default {
  name: 'trade',
  metaInfo: {
    title: 'trade',
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=yes' }
    ]
  },

  data: () => ({
    id: '',
    item: {},
    src: '',
    numPages: 0,
    protocol: {},
    currentPage: 1, // 当前页码
    pageCount: 0, // 总页码
  }),
  beforeMount() {
    this.item = this.$route.query.item || {}
    if (Object.keys(this.item).length > 0) {
      const url = this.item.url || ''
      this.src = pdf.createLoadingTask({ url: url, CMapReaderFactory })
      this.loadPdfHandler();
      this._dismissLoading()
    }
    wx.hideOptionMenu()
  },
  methods: {
    loadPdfHandler() {
      this.src.promise.then(pdf => {
        this.numPages = pdf.numPages;
      })
    },
  },
  components: {
    pdf,
    [NavBar.name]: NavBar,
    [Toast.name]: Toast,
  },
  destroyed() {
    wx.showOptionMenu()
  },
}
</script>
    
<style lang="less" scoped>
.content {
  padding: 20px;
}
.van-nav-bar {
  background: #fff;

  .van-nav-bar__title {
    color: @dark;
  }
  .van-icon {
    color: @dark !important;
  }
}
</style>
